import type { NextPage } from 'next';
import { createContext, useContext, useMemo } from 'react';
import { Loader } from '@itandi/itandi-bb-ui';
import { Page as Component } from '~/components/specifics/new/Page';
import { NskHead } from '~/components/common/head/NskHead';
import { useDealInfoFromRouter } from '~/hooks/useDealInfoFromRouter';
import type { DealInfo as KtDealInfo } from '~/utils/NyukyoshaKanriUrlUtil';
import useItandiAccount from '~/hooks/useItandiAccount';
import { ItandiAccountContext } from '~/models/ItandiAccount';

interface DealQueryParamsContextValue {
  leasingId: KtDealInfo['leasingId'];
  dealType: KtDealInfo['dealType'];
}

const DealQueryParamsContext = createContext<DealQueryParamsContextValue>({
  leasingId: null,
  dealType: null
});

export const useDealQueryParams = (): DealQueryParamsContextValue =>
  useContext(DealQueryParamsContext);

export const PATH = '/deals/new';

const New: NextPage = () => {
  const { data: account } = useItandiAccount().currentAccount();
  const { leasingId, dealType, isReady } = useDealInfoFromRouter();
  const value = useMemo(() => ({ leasingId, dealType }), [leasingId, dealType]);
  if (!isReady || account === null) return <Loader />;

  return (
    <>
      <NskHead title="案件追加" />
      <ItandiAccountContext.Provider value={account}>
        <DealQueryParamsContext.Provider value={value}>
          <Component />
        </DealQueryParamsContext.Provider>
      </ItandiAccountContext.Provider>
    </>
  );
};

export default New;
